<template>
  <div class="container">
    <h1>SMS Inbox</h1>
    <div class="row margin-bottom-2">
      <div class="col-xs-4">
        <DevAppDropDownComponent role="receive_sms" @devapp-changed="devAppChanged"/>
      </div>
      <sdx-loading-spinner id="spinner-inboxes" size="large" sr-hint="Loading. Please wait."></sdx-loading-spinner>
      <div id="inboxes" v-if="showInbox" class="col-xs-4">
        <div v-if="!isLoading">
          <sdx-select
              id="smsInboxDropDown"
              data-testid="smsInboxDropDown"
              label="Inbox"
              placeholder="Choose an Inbox..."
              keyboard-behavior="filter"
              filter-min-length="2"
              @input="selectedInbox"
              v-model="inbox">
            <sdx-select-option
                v-for="inbox in inboxes"
                id="smsInboxDropDownOption"
                data-testid="smsInboxDropDownOption"
                :key="inbox.inboxName"
                :value="inbox">
              {{ inbox.inboxName }}
            </sdx-select-option>
          </sdx-select>
        </div>
      </div>
    </div>
    <h4 data-testId="replyNumber" class="margin-v-2" v-if="this.replyNumber!=undefined">Reply number: {{ this.replyNumber }} <span
        v-if="isExclusiveInbox()">(Exclusive)</span></h4>
    <sdx-loading-spinner id="spinner-inbox-content" size="large" sr-hint="Loading. Please wait."></sdx-loading-spinner>
    <div id="inbox-content" v-if="showInboxTable">
      <div v-if="!TableIsLoading" class="sms-inbox-table table table--responsive table--highlight">
        <div class="table_wrapper">
          <table data-init="auto">
            <thead>
            <tr>
              <th class="table-header">Country</th>
              <th class="table-header">Sender</th>
              <th>Status
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more" data-testid="infoStatus"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content style="width: 500px;">
                    <table border="0">
                      <tbody>
                      <tr>
                        <td><span class="sc-blue">NEW</span>:</td>
                        <td>SMS was never collected via API</td>
                      </tr>
                      <tr>
                        <td><span class="sc-blue">READ</span>:</td>
                        <td>SMS was collected via API</td>
                      </tr>
                      </tbody>
                    </table>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
              </th>
              <th class="table-header">Received</th>
              <th class="table-header">Message</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in receivedSms" id="smsInboxTable" :key="item">
              <td class="table-cell">
                <FlagComponent :country="item['originRegionCode']"/>
              </td>
              <td>{{ item.from }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.received }}</td>
              <td v-if="item.message.length > 50" title="Click to show full SMS" class="message-length">
                <a
                    @click="showFullSmsContent(item.message)"
                    label="Show SMS"
                >
                  {{ item.message }}
                </a>
              </td>
              <td v-if="item.message.length <= 50" class="message-length">{{ item.message }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="receivedSms.length === 0" class="no-items-found">
          <br/>
          <p><i>No inbox items found</i></p>
        </div>
      </div>
      <div class="Modal-Design">
        <sdx-dialog

            type="modal"
            id="inbox-sms"
            label="SMS Content"
            icon-name="icon-sms">
          <sdx-dialog-content class="sms-Content">
            <!--<div class="SMS-Content-Border">-->
            <p>
              {{ this.message }}
            </p>
            <!--</div>-->
            <sdx-button-group>
              <!--<div class="SDX-Button-Modal">-->
              <sdx-button
                  id="first-action-element"
                  label="Close"
                  onclick="document.getElementById('inbox-sms').close()"
                  theme="primary">
              </sdx-button>
              <!--</div>-->
            </sdx-button-group>
          </sdx-dialog-content>
        </sdx-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent";
import smsInboxService from '../service';
import loadingSpinnerService from '@/services/loading-spinner.service';
import FlagComponent from "@/components/FlagComponent";
import {showAlert} from "@/services/notification.service";

export default {
  components: {
    FlagComponent,
    DevAppDropDownComponent,
  },
  data: function () {
    return {
      webId: undefined,
      inboxes: [],
      inbox: undefined,
      inboxName: undefined,
      replyNumber: undefined,
      receivedSms: [],
      message: undefined,
      showInbox: false,
      showInboxTable: false,
      isLoading: false,
      TableIsLoading: false,
    }
  },
  async mounted() {
    await this.loadInboxes();
    await this.loadData();
  },
  methods: {
    devAppChanged: async function (webId) {
      this.webId = webId;
      this.receivedSms = [];
      this.showInboxTable = false;
      await this.loadInboxes();
    },
    getDevAppWebId: async function () {
      return this.$refs.devAppDropDownComponent.getDevAppWebId();
    },
    loadInboxes: async function () {
      loadingSpinnerService.show("inboxes");
      this.replyNumber = undefined;
      if (this.webId === undefined || this.webId === null || this.webId === '') {
        this.showInbox = false
        this.showInboxTable = false
      } else {
        this.isLoading = true;
        this.showInbox = true;
        try {
          const response = await smsInboxService.getSmsInboxes(this.webId);
          this.inboxes = response.data;
          this.replyNumber = this.inboxes[0]?.replyNumber;
        } catch (error) {
          showAlert("Could not load inboxes!")
          this.inboxes = [];
        }
        this.isLoading = false;
      }
      loadingSpinnerService.hide("inboxes");
    },
    loadData: async function () {
      loadingSpinnerService.show("inbox-content");
      if (this.inboxName === undefined || this.inboxName === null || this.inboxName === '') {
        this.showInboxTable = false;
      } else {
        this.showInboxTable = true;
        this.TableIsLoading = true;
        try {
          let response = await smsInboxService.getInbox(this.webId, this.replyNumber, this.inboxName);
          this.receivedSms = response.data;
        } catch (error) {
          showAlert("Could not load inbox:  " + this.inboxName + " !");
          this.receivedSms = [];
        }
        this.TableIsLoading = false;
      }
      loadingSpinnerService.hide("inbox-content");
    },
    selectedInbox: function () {
      this.inbox = arguments[0].target.value;
      if (this.inbox[0] === undefined) {
        this.inboxName = undefined;
        this.replyNumber = undefined;
        this.showInboxTable = false;
      } else {
        this.inboxName = this.inbox[0].inboxName;
        this.replyNumber = this.inbox[0].replyNumber;
      }
      this.loadData();
    },
    showFullSmsContent: async function (message) {
      this.message = message;
      document.getElementById('inbox-sms').open()
    },
    isExclusiveInbox: function () {
      return this.inboxes != undefined && this.inboxes.includes(inbox => inbox.inboxName === "DEFAULT");
    }
  }
}
</script>

<style>

.sms-inbox-table .table-cell {
  padding-top: 5px;
  padding-bottom: 2px;
}

.sms-inbox-table .table-cell {
  border-radius: 20px;
}

.sms-inbox-table.table tbody td {
  padding-top: 5px;
  padding-bottom: 3px;
}

.table-is-loading {
  margin-top: 30px;
  margin-bottom: 30px;
}

.inbox-dropdown-is-loading {
  margin-top: 1px;
  margin-bottom: 1px;
}

.sms-inbox-dropdown {
  padding-top: 1px;
}

.message-length {
  max-width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sms-Content {
  max-width: 30%;
}
</style>